import {
  CatalogBannerListState,
  CatalogCreationBannerFieldConfig,
} from '../../../../../creation/catalogCreationForm.types';
import CatalogBannerGallery from '../../../../../creation/components/CatalogBannerGallery/CatalogBannerGallery';
import { useCatalogBannerList } from '../../../../../creation/hooks/useCatalogBannerList';

interface CatalogBannersModalFieldProps {
  config: CatalogCreationBannerFieldConfig;
  savedUrls: string[];
  onChange: (state: CatalogBannerListState) => void;
}

const CatalogBannersModalField = ({
  config,
  savedUrls,
  onChange,
}: CatalogBannersModalFieldProps) => {
  const { previews, addFiles, removeFile, moveFile } = useCatalogBannerList({
    uploadWidth: config.dimensions.width,
    initialUrls: savedUrls,
    onChange,
  });

  return (
    <CatalogBannerGallery
      label={config.label}
      dimensions={config.dimensions}
      isFluid
      previews={previews}
      onAddFiles={addFiles}
      onRemoveFile={removeFile}
      onMoveFile={moveFile}
    />
  );
};

export default CatalogBannersModalField;
